import { safeClone, ViewStream } from "spyne";
import { SidebarRenderTraits } from "traits/sidebar-render-traits";
import { SidebarTraits } from "traits/sidebar-traits";

export class SidebarMenuView extends ViewStream {
  constructor(props = {}) {
    props.tagName = "nav";
    props.traits = SidebarRenderTraits;
    props.class = `sidebar-menu menu-${props.menuType}`;
    props.data = safeClone(props.data);

    const dataHashTable = {
      docs: props.data.docsContent,
      tools: props.data.toolsPageContent,
      compare: props.data.comparePageContent,
      reference: props.data.referencePageContent,
      configure: props.data.configuratorPageContent,
    };

    const isDocsPage = false; // removed docs option for views, behavior, logic containers props.pageId === 'docs';

    if (isDocsPage === true) {
      props["renderData"] =
        SidebarRenderTraits.sidebarRender$ConformDataForDocsContainers(
          dataHashTable[props.pageId],
        );
      props.data.sidebarData = props.renderData.sidebarData;
    } else {
      props.data.sidebarData = dataHashTable[props.pageId];
    }

    const mapSidebarData = (o) => {
      const { isSidebarSection, sidebarIndent } = o;

      o["sidebarSection"] = isSidebarSection ? "sidebar-section" : "";
      o["sidebarIndent"] =
        sidebarIndent !== undefined ? `sidebar-indent-${sidebarIndent}` : "";
      o.menuData.section ??= o.menuData.container;
      return o;
    };

    if (props.pageId === "reference") {
      safeClone(props.data.sidebarData.map(mapSidebarData));
    }

    //console.log("PROPS DATA SIDEBAR MENU ", props);
    // props.data.sidebarData = props.pageId==='docs' ? props.data.docsContent : props.data.comparePageContent;

    props.template = require("./templates/sidebar-menu-quick-start.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_SIDEBAR_REVEAL_PANEL", "onRemoveSidebarMenu"],
      ["CHANNEL_SIDEBAR_HIDE_PANEL", "onRemoveSidebarMenu"],
      ["CHANNEL_SIDEBAR_NAVIGATION_EVENT", "onNavEvent"],
    ];
  }

  onRouteCardEvent(e) {
   //console.log("ROUTE CARD EVENT ", e);
  }

  onNavEvent(e) {
    const { payload, srcElement } = e;
    const { routeData } = payload;

    const isMethodLink = payload?.pathsChanged?.[0] === "classMethod";

    if (isMethodLink) {
      return;
    }

    // A click on one of THIS menu's own links highlights it directly.
    // Clicks arriving from other surfaces (clProseLinks bullets, card
    // grids, the top nav) carry a foreign element — fall through and
    // resolve the menu link from route data instead.
    if (
      srcElement?.el !== undefined &&
      this.props.el.contains(srcElement.el)
    ) {
      this.setMenuEl(srcElement.el);
      return;
    }

    // Spy/route-driven changes have no source element. Resolve the menu
    // link from route data attributes — item ids are randomly generated
    // per render, so they cannot be matched between content and menu.
    const el =
      this.getMenuElByRouteData(routeData) || this.getMenuElByItemId(payload);

    // No resolvable target: keep the current highlight rather than
    // clearing it with an undefined element.
    if (el !== undefined && el !== null) {
      this.setMenuEl(el);
    }
  }

  getMenuElByRouteData(routeData = {}) {
    const { stage, container, section } = routeData;

    if (stage === undefined || stage === "") {
      return undefined;
    }

    const stageSel = `a[data-stage='${stage}']`;
    const containerSel = container
      ? `[data-container='${container}']`
      : `[data-container='']`;
    const sectionSel = section
      ? `[data-section='${section}']`
      : `[data-section='']`;

    // Deepest match first, then fall back up the hierarchy so a route
    // deeper than the rendered menu still highlights its parent link.
    const selectors = [
      `${stageSel}${containerSel}${sectionSel}`,
      `${stageSel}${containerSel}[data-section='']`,
      `${stageSel}[data-container=''][data-section='']`,
    ];

    for (const sel of selectors) {
      const el = this.props.el$(sel).el;
      if (el !== undefined && el !== null) {
        return el;
      }
    }

    return undefined;
  }

  getMenuElByItemId(payload) {
    const itemId = payload?.itemId ?? payload?.routeData?.itemId;

    if (itemId === undefined || itemId === false) {
      return undefined;
    }

    return this.props.el$(`[data-item-id='${itemId}']`).el;
  }

  setMenuEl(el) {
    this.props.el$("a").setActiveItem("selected", el);
  }

  setMenuSelected(
    itemId = this.props.itemId,
    typeId = this.props.typeId,
    pageId = this.props.pageId,
  ) {

    const isDocs = this.props.pageId === 'docs';
    //const classSel = `a.item-${pageId}-${typeId}-${exampleId}`;
    const sel = isDocs ? itemId : `[data-item-id='${itemId}']`;
    this.props.el$("a").setActiveItem("selected", sel);

    if (this.props.pageId === "docs" && this?.props?.initPayload?.isDeepLink === true && this.props?.initPayload?.routeData?.stage === 'examples'){
      const { container } = this.props?.initPayload?.routeData;

      if (container !== undefined && String(container).length>2){
        const data = this.props.el$(`${sel}`).el.dataset;
        const payload = {...data};

       const delay = ()=> this.sendInfoToChannel("CHANNEL_ROUTE", payload);

       window.setTimeout(delay, 100);
         ////console.log("RUN DATA ",data);
      }


      //this.sendInfoToChannel("CHANNEL_ROUTE", data);

    }

   //console.log(" SET MENU SELECTED ",this.props.pageId,{typeId, itemId},  this.props.el$(sel).exists)
  }

  onRemoveSidebarMenu() {
    this.disposeViewStream();
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["nav a", "click"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_SIDEBAR", true);
    this.setMenuSelected();
    if (this.props.pageId === "docs") {
      // this.sidebarRender$ContainerSections();
    }
    // window.setTimeout(this.setMenuSelected.bind(this), 1000);
  }
}
